import webappInfo from '#src/webappInfo';

/**
 * Returns the URL we send to (and that the shortener hashes against). In production
 * this is the longUrl unchanged. In dev environments running against a proxy
 * target, the shortener doesn't accept local-change.org hosts, so we rewrite
 * the host to the proxy target. `generateShareId` must be computed against this
 * same string to keep the local hash and the shortener hash in parity.
 */
export function getNormalizedLongUrl(longUrl: string): string {
	if (!webappInfo.proxyTarget?.root) return longUrl;
	return longUrl.replace(/^https?:\/\/[^/]*\//, `${webappInfo.proxyTarget.root}/`);
}
